import { ReactNode, useEffect } from 'react';

import { DyteProvider, useDyteClient } from '@dytesdk/react-web-core';
import { provideDyteDesignSystem } from '@dytesdk/react-ui-kit';
import { useThemeContext } from 'src/context/ThemeProvider';

type DyteTheme = 'darkest' | 'dark' | 'light';

type Props = {
	children: ReactNode;
	token: string;
};

const InterviewLayout = ({ children, token }: Props) => {
	const { themeMode } = useThemeContext();
	const [client, initClient] = useDyteClient();

	useEffect(() => {
		if (token) {
			provideDyteDesignSystem(document.body, {
				theme: themeMode as DyteTheme,
			});

			initClient({
				authToken: token,
				defaults: { audio: true, video: true },
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [token]);

	return (
		<div className="h-full flex flex-col">
			<DyteProvider value={client} fallback>
				{children}
			</DyteProvider>
		</div>
	);
};

export default InterviewLayout;
